import { EventBus } from "../../../eventbus";

export default {
  props: {
    name: String,
    icon: String,
    url: String,
    urlIsExternal: Boolean,
    rights: Array,
    extraMenu: Array,
    emitterName: String,
    emitterData: Object,
  },
  data() {
    return {
      extraMenuOpen: false,
    };
  },
  methods: {
    goTo(url) {
      this.$router.push({ path: url });
    },
    handleClickLink(e) {
      e.preventDefault();

      if (this.emitterName) {
        //preform action
        EventBus.$emit(this.emitterName, this.emitterData);
      } else if (this.extraMenu) {
        //open extra menu
        this.extraMenuOpen = true;
      } else {
        //go to internal page
        this.goTo(e.currentTarget.getAttribute("href"));
      }
    },

    handleClickMoreLink(e) {
      e.preventDefault();
      this.goTo(e.currentTarget.getAttribute("href"));
    },
    closeExtraMenu(e) {
      e.preventDefault();
      this.extraMenuOpen = false;
    },
  },
};
